import { Component, Input } from '@angular/core';
import { NgIf, NgFor, NgStyle } from '@angular/common';

interface Cabecalho {
  titulo: string;
  subtitulos?: string[];
  tamanho: string;
}

@Component({
  selector: 'app-tabela',
  standalone: true,
  imports: [NgIf, NgFor, NgStyle],
  templateUrl: './tabela.component.html',
  styleUrl: './tabela.component.scss',
})
export class TabelaComponent {
  @Input() cabecalhos: Cabecalho[] = [];
  @Input() cabecalhoCustomizado: boolean = false;

  constructor() {}

  public subtitulos(): string[] {
    const subtitulos: string[] = [];

    const titulosComSubtitulos = this.cabecalhos.filter(
      (titulo) => titulo.subtitulos,
    );

    if (!titulosComSubtitulos) return [];

    titulosComSubtitulos.forEach((titulo: Cabecalho) => {
      subtitulos.push(...[...(titulo.subtitulos as string[])]);
    });

    return subtitulos;
  }
}
